import React from 'react';
import { useEffect } from 'react';
import '../Addon.css'

export const Cakes = ({cart, item, handleClick}) => {
    const {title, price, img, recipe} = item;
    

  return (
    
    <div className="product-card">
        <div className="product-image">
          <img src={img} alt="Rich Chocolate Cream"/>
          <div class="overlay">{recipe}</div>
        </div>
        <div className="product-info">
          <h5>{title}</h5>
          <h6>&#8377; {price} / kg</h6>
          <button onClick={() => handleClick(item)}>Add to Cart</button>
        </div>
      </div>
          
  )
}
export default Cakes;
